import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList,
} from 'recharts';
import DashboardCard from './DashboardCard';
import { BRAND } from '../styles';

// Kart 2/7 — Huni: aşamaya göre aday sayısı, `order` alanına göre sıralı,
// yatay bar (brief).
export default function FunnelCard({ data, loading }) {
  const { t, i18n } = useTranslation();

  const rows = useMemo(() => (
    [...(data || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
  ), [data]);

  const chartHeight = Math.max(160, rows.length * 40);

  return (
    <DashboardCard
      cardKey="huni"
      title={t('atsDashboard.funnel.title')}
      meta={t('atsDashboard.funnel.meta')}
      span={7}
      spanMd={6}
      loading={loading}
      empty={rows.length === 0}
      domId="ats-dash-funnel"
    >
      <ResponsiveContainer width="100%" height={chartHeight}>
        <BarChart
          data={rows}
          layout="vertical"
          margin={{ top: 4, right: 28, bottom: 0, left: 4 }}
        >
          <XAxis type="number" hide allowDecimals={false} />
          <YAxis
            type="category"
            dataKey="stageName"
            width={110}
            tickLine={false}
            axisLine={{ stroke: BRAND.border }}
            tick={{ fontSize: 11, fill: '#6B7280' }}
          />
          <Tooltip
            cursor={{ fill: 'rgba(2, 211, 191, 0.06)' }}
            formatter={(value) => [t('atsDashboard.funnel.candidateCount', { count: value }), null]}
          />
          <Bar dataKey="count" fill={BRAND.primary} barSize={20} radius={[0, 4, 4, 0]}>
            <LabelList
              dataKey="count"
              position="right"
              formatter={(v) => Number(v).toLocaleString(i18n.language)}
              style={{ fill: BRAND.textDark, fontSize: 12, fontWeight: 700 }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </DashboardCard>
  );
}
